import React, { FC, Fragment, useState } from 'react';
import SwipeableViews from 'react-swipeable-views';
import DetailsCard from '../scenes/DetailsCard';
import WallCard from '../scenes/WallCard';
import PlanningCard from '../scenes/PlanningCard';
import InterventionsCard from '../scenes/InterventionsCard';
import Ticket from 'src/interfaces/api/Ticket';
import { Tab, Tabs } from 'src/components/Tabs';

interface Route {
  path: string;
  label: string;
  hash: string;
  component: any;
}

const routes: Array<Route> = [
  {
    path: 'details',
    label: 'Details',
    hash: '#details',
    component: DetailsCard,
  },
  {
    path: 'wall',
    label: 'Mur',
    hash: '#wall',
    component: WallCard,
  },
  {
    path: 'interventions',
    label: 'Interventions',
    hash: '#interventions',
    component: InterventionsCard,
  },
  {
    path: 'planning',
    label: 'Planning',
    hash: '#planning',
    component: PlanningCard,
  },
];

interface Props {
  ticket: Ticket;
  pageHash?: string;
  onChangePageHash: (newHash: string) => void;
}

const TicketNavigation: FC<Props> = ({ onChangePageHash, pageHash, ticket }) => {
  const startPageIndex = routes.findIndex((route) => route.hash === pageHash);
  const [currentPage, setCurrentPage] = useState(startPageIndex === -1 ? 0 : startPageIndex);

  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    handlePageChange(newValue);
  };

  const handlePageChange = (index: number) => {
    onChangePageHash(routes[index].hash);
    setCurrentPage(index);
  };

  return (
    <Fragment>
      <Tabs
        indicatorColor='primary'
        textColor='primary'
        variant='scrollable'
        scrollButtons='auto'
        value={currentPage}
        onChange={handleTabChange}
      >
        {routes.map((route, key) => (
          <Tab key={key} label={route.label} value={key} />
        ))}
      </Tabs>

      <SwipeableViews index={currentPage} onChangeIndex={handlePageChange}>
        {routes.map((route, key) => {
          const Component = route.component;

          return <Component key={key} hidden={key !== currentPage} wallId={ticket.id} ticket={ticket} />;
        })}
      </SwipeableViews>
    </Fragment>
  );
};

export default TicketNavigation;
